module.exports = __webpack_public_path__ + "img/flag-red.8dd5a63f.svg";